import React from "react";
import { SERVICE_CATEGORIES } from "./nearby-utils";
import { ICON_STROKE } from "../ui/icon";

const NearbyCategoryChips = ({ activeType, onChange }) => (
  <div className="nearby-categories" role="tablist" aria-label="Service type">
    {SERVICE_CATEGORIES.map(({ key, label, emoji, icon: Icon }) => {
      const active = activeType === key;
      return (
        <button
          key={key}
          type="button"
          role="tab"
          aria-selected={active}
          onClick={() => onChange(key)}
          className={`nearby-chip ${active ? "nearby-chip--active" : ""}`}
        >
          <span className="nearby-chip__icon-wrap" aria-hidden>
            {Icon ? <Icon size={18} strokeWidth={ICON_STROKE} /> : <span>{emoji}</span>}
          </span>
          <span>{label}</span>
        </button>
      );
    })}
  </div>
);

export default NearbyCategoryChips;
